export default "__VITE_ASSET__Dzn9GipX__"